import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader } from "./States";
import { WORKER_ROLE_OPTIONS } from "@/lib/constants";

export const homeFor = (profile) => (profile?.role === "manager" ? "/manager" : "/jobs");

export function RequireRole({ role, children }) {
  const { profile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageLoader />;
  if (!profile) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  const matches = profile.role === role || (role === "locksmith" && WORKER_ROLE_OPTIONS.some(([workerRole]) => workerRole === profile.role));
  if (!matches) return <Navigate to={homeFor(profile)} replace />;
  return children;
}

export function RequireMember({ children }) {
  const { profile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageLoader />;
  if (!profile) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export function HomeRedirect() {
  const { profile, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!profile) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(profile)} replace />;
}
